module.exports = __webpack_public_path__ + "img/block_1.a2e6f9ed.webp";